import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { logout } from "../../../store/actions/UserActions";

class Header extends Component {
  componentDidMount() {}
  render() {
    return (
      <header className="main-header" style={{position: "fixed", width: "100%"}}>
        <a href="#" className="logo">
          <span className="logo-mini">
            <b>A</b>LT
          </span>
          <span className="logo-lg">
            <b>Admin</b>LTE
          </span>
        </a>
        <nav className="navbar navbar-static-top" role="navigation">
          <a
            href="#"
            className="sidebar-toggle"
            data-toggle="push-menu"
            role="button"
          >
            <span className="sr-only">Toggle navigation</span>
          </a>
          <div className="navbar-custom-menu">
            <ul className="nav navbar-nav">
              {/* <li className="dropdown messages-menu">
                <a href="#" className="dropdown-toggle" data-toggle="dropdown">
                  <i className="fa fa-envelope-o" />
                  <span className="label label-success">4</span>
                </a>
                <ul className="dropdown-menu">
                  <li className="header">You have 4 messages</li>
                  <li>
                    <ul className="menu">
                      <li>
                        <a href="#">
                          <div className="pull-left">
                            <img
                              src="img/user2-160x160.jpg"
                              className="img-circle"
                              alt="User Image"
                            />
                          </div>
                          <h4>
                            Support Team
                            <small>
                              <i className="fa fa-clock-o" /> 5 mins
                            </small>
                          </h4>
                          <p>Why not buy a new awesome theme?</p>
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li> */}

              <li className="dropdown user user-menu">
                <a
                  href="#"
                  className="dropdown-toggle"
                  data-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img
                    src="/img/user2-160x160.jpg"
                    className="user-image"
                    alt="User Image"
                  />
                  <span className="hidden-xs">{this.props.user.username || "No name"}</span>
                </a>
                <ul className="dropdown-menu">
                  <li className="user-header">
                    <img
                      src="/img/user2-160x160.jpg"
                      className="img-circle"
                      alt="User Image"
                    />

                    <p>
                      {this.props.user.username || "No name"}
                      {/* <small>Member since Nov. 2012</small> */}
                    </p>
                  </li>

                  {/* <li className="user-body">
                    <div className="row">
                      <div className="col-xs-4 text-center">
                        <a href="#">Followers</a>
                      </div>
                      <div className="col-xs-4 text-center">
                        <a href="#">Sales</a>
                      </div>
                      <div className="col-xs-4 text-center">
                        <a href="#">Friends</a>
                      </div>
                    </div>
                  </li> */}

                  <li className="user-footer">
                    {/* <div className="pull-left">
                      <a href="#" className="btn btn-default btn-flat">
                        Profile
                      </a>
                    </div> */}
                    <div className="pull-right">
                      <a className="btn btn-default btn-flat" onClick={() => this.props.userLogout(() => {this.props.history.push("/")})}>
                        Sign out
                      </a>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </nav>
      </header>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user
})

function mapDispatchToProps(dispatch) {
  return {
    userLogout: bindActionCreators(logout, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header))